import { createApp } from 'vue'
import App from './App.vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
import Maska from 'maska'
const app = createApp(App);
app.use(Maska)
app.mount("#app");
